import { useFlags } from 'launchdarkly-react-client-sdk';
import useQueryParams from '../navigation-utils/useQueryParams';

export const useFeatureToggle = () => {
  const query = useQueryParams();

  const debugTools = query.has('debugTools');

  // Please remove feature toggles no longer in use when merging an experiment
  // This list should have all currently used feature toggle flags.
  const {
    reportsComingSoonTag,
    orgFactoryReset,
    sweepSupportChat,
    priorValueSlackMessages,
    assignmentGroupRoles,
    sfLoginHistory,
    lgDemo,
    impactAnalysisAiAgent,
    deployAutomationAsFlow,
    hubspotV25,
    permissionsAgent,
    msTeamsCreateAndAddAction,
    tagsCenter,
    automationsAiForCreation,
    supportAgentInAgenticCenter,
    sfFieldFieldsDialog,
    deleteFunnel,
    processMiningV2,
    canvasToolbar,
    canvasSections,
    setAsMcp,
    searchInDocumentationCard,
    dreamforceDemo,
    canvasStickyNotes,
    universalSearchRedesign,
    usedByInMetadataElements,
    monitoringOnHomepage,
    multiAccounts,
    documentationAgentAdvancedMode,
    agentResearchMode,
    snowflakeConnection,
    deployFromFunnelLabel,
    weightedGroups,
    promptsLibraryV2,
    multiOrgQuery,
    slackAssignee,
    artifactsPage,
    metadataMappingUpdate,
    wizFuzzyDemo,
    artifactTemplates,
    funnelMapCanvasPreviews,
  } = useFlags();

  return {
    debugTools,
    reportsComingSoonTag,
    orgFactoryReset,
    sweepSupportChat,
    priorValueSlackMessages,
    assignmentGroupRoles,
    sfLoginHistory,
    lgDemo,
    impactAnalysisAiAgent,
    deployAutomationAsFlow,
    hubspotV2_5: hubspotV25,
    permissionsAgent,
    msTeamsCreateAndAddAction,
    tagsCenter,
    automationsAiForCreation,
    supportAgentInAgenticCenter,
    sfFieldFieldsDialog,
    deleteFunnel,
    processMiningV2,
    canvasToolbar,
    canvasSections,
    setAsMcp,
    searchInDocumentationCard,
    dreamforceDemo,
    canvasStickyNotes,
    universalSearchRedesign,
    usedByInMetadataElements,
    monitoringOnHomepage,
    multiAccounts,
    documentationAgentAdvancedMode,
    snowflakeConnection,
    agentResearchMode,
    deployFromFunnelLabel,
    weightedGroups,
    promptsLibraryV2,
    artifactsPage,
    multiOrgQuery,
    slackAssignee,
    metadataMappingUpdate,
    wizFuzzyDemo,
    artifactTemplates,
    funnelMapCanvasPreviews,
  };
};
